import { ILocationService } from "angular";
import { storage } from "@gtmhub/core/storage";

export class LastUrlService {
  public static $inject = ["$location"];

  constructor(private $location: ILocationService) {}

  public storeCurrentLocation(toPath: string): void {
    // don't store default page or /error page as last page url
    const errorPageSuffix = "/error";
    if (toPath === "/" || toPath.indexOf(errorPageSuffix, toPath.length - errorPageSuffix.length) >= 0) {
      return;
    }

    storage.set("originalReqSearch", this.$location.search());
    storage.set("originalReqPath", toPath);
  }

  public getStoredLocationSearch(): string {
    return storage.get<string>("originalReqSearch");
  }

  public getStoredLocationPath(): string {
    return storage.get<string>("originalReqPath");
  }

  public clear(): void {
    storage.remove("originalReqSearch");
    storage.remove("originalReqPath");
  }
}
